import { ScheduleBacnetTranslations } from "./scheduleBacnetTranslations";

export const ruScheduleBacnetTranslations: ScheduleBacnetTranslations = {

    schedulesList: "Список расписаний",
    weeklySchedule: "Недельное расписание",
    exceptions: "Исключения",

    newWindow: "Новое окно",

    more: "Ещё",

    today: "Сегодня",
    day: "День",
    workWeek: "Рабочая неделя",

    createWeeklySchedule: "Создать недельное расписание",
    editWeeklySchedule: "Редактировать недельное расписание",
    createException: "Создать исключение",
    editException: "Редактировать исключение",
    editExceptions: "Редактировать исключения",

    event: "Событие",
    exception: "Исключение",

    areYouSureYouWantToDelete: "Вы уверены, что хотите удалить",

    deletion: "Удаление",
    eventDeleteConfirmation: "Вы уверены, что хотите удалить событие?",

    edit: "Редактировать",
    add: "Добавить",
    exceptionFieldPriority: "Приоритет",

    addWeekSchedule: "Добавить недельное расписание",
    addException: "Добавить исключение",
    editEvent: "Редактировать событие",
    deleteEvent: "Удалить событие",
    duplicateEvent: "Дублировать событие",

    time: "Время",
    dataType: "Тип данных",
    value: "Значение",

    chooseDataType: "Выберите тип значения",

    period: "Период",
    choosePeriod: "Выберите период",

    date: "Дата",
    range: "Диапазон",
    weekAndDay: "Неделя и день",

    enterYear: "Введите год",

    errorPeriodTypeNotChosen: "Тип периода не установлен",
    errorIncorrectDayOfMonth: "Некорректно заполнен день месяца",
    errorIncorrectDayOfWeek: "Некорректно указан день недели",
    errorStartDateBeforeEndDate: "Начальная дата должна быть раньше конечной",
    errorDaysOfMonthDoNotMatch: "Дни месяца не совпадают",
    errorMonthsDoNotMatch: "Месяцы не совпадают",
    errorNeedToChooseCalendarId: "Необходимо указать ID календаря",

    errorNoDaysSelected: "Не выбран день недели",
    errorNoEventsAdded: "Не добавлено ни одного события",
    errorNoTimeSelected: "Не выбрано время",
    errorNoDataTypeSelected: "Не выбран тип данных",
    errorNoValueSelected: "Не выбрано значение",
    errorValuesDoNotMatchType: "Значение не соответствует типу",

    errorValueMustBeNonNegativeInteger: "Значение должно быть неотрицательным целым числом",
    errorValueMustBeInteger: "Значение должно быть целым числом",
    errorValueMustBeNumber: "Значение должно быть числом",

    unknownValue: "Неизвестное значение",
    valuesNotFound: "Значение не найдены",

    dayOfWeek: "День недели",
    dayOfMonth: "День месяца",
    week: "Неделя",
    month: "Месяц",
    year: "Год",
    anyDayAnyMonthAnyYear: "Любой день, любой месяц, любой год",

    start: "Начало",
    end: "Конец",

    calendarLink: "Ссылка на календарь",
    calendarID: "Идентификатор календаря",

    january: "Январь",
    february: "Февраль",
    march: "Март",
    april: "Апрель",
    may: "Май",
    june: "Июнь",
    july: "Июль",
    august: "Август",
    september: "Сентябрь",
    october: "Октябрь",
    november: "Ноябрь",
    december: "Декабрь",

    daysOfWeek: "Дни недели",

    su: "Вс",
    mo: "Пн",
    tu: "Вт",
    we: "Ср",
    th: "Чт",
    fr: "Пт",
    sa: "Сб",

    sunday: "Воскресенье",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",

    anyWeekDay: "Любой день недели",

    anyDayOfMonth: "Любой день месяца",
    lastDay: "Последний день",
    oddDays: "Нечетные дни",
    evenDays: "Четные дни",

    anyMonth: "Любой месяц",
    evenMonths: "Четные месяцы",
    oddMonths: "Нечетные месяцы",

    anyYear: "Любой год",
    selected: "Выбранный",

    anyWeek: "Любая неделя",
    firstWeek: "1-ая неделя",
    secondWeek: "2-ая неделя",
    thirdWeek: "3-ая неделя",
    fourthWeek: "4-ая неделя",
    fifthWeek: "5-ая неделя",
    lastSevenDaysOfMonth: "Последние 7 дней месяца",

};
